import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

connectedCallback() {
  super.connectedCallback();

  const { videoSources, videoElement } = this.refs;

  for (const source of videoSources) {
    const { videoSource } = source.dataset;

    if (videoSource) source.setAttribute('src', videoSource);
  }

  videoElement.load();

  videoElement.muted = true;
  videoElement.autoplay = true;
  videoElement.playsInline = true;

  const playVideo = () => {
    videoElement.style.opacity = '1';
    videoElement.style.visibility = 'visible';
    videoElement.style.display = 'block';

    videoElement.play().catch((err) => {
      console.log('Background video autoplay failed:', err);
    });
  };

  if (videoElement.readyState >= 2) {
    playVideo();
  } else {
    videoElement.addEventListener('loadeddata', playVideo, { once: true });
  }
}
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
